import React from "react";

const DataSources = ({ sources }) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 mb-8 border-t border-gray-300 pt-6 text-center text-sm text-gray-700 max-w-3xl mx-auto px-4">
      <p className="font-semibold mb-3">Data Sources:</p>
      <div className="flex flex-col items-center gap-2">
        {sources.map((source, index) => (
          <a
            key={index}
            target="_blank"
            href={source}
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline break-all"
          >
            {source}
          </a>
        ))}
      </div>
    </div>
  );
};

export default DataSources;



